import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { faCommentAlt } from '@fortawesome/free-solid-svg-icons';
import OrientationsList from './OrientationsList';
import LocationsList from './LocationsList';
import { pushHistoryState, stripHash } from '../../../helpers/routing';
import ListPageHeader from '../../common/lists/ListPageHeader';
import CreateOrientationModal from './CreateOrientationModal';
import { getOrientationLocationsList, createOrientation, getOrientationsList } from '../../../actions/orientations';

const orientationTabs = {
  orientations: 'Upcoming',
  locations: 'Locations'
};

class Orientations extends Component {
  static propTypes = {
    locationsList: PropTypes.array.isRequired,
    getOrientationLocationsList: PropTypes.func.isRequired,
    getOrientationsList: PropTypes.func.isRequired,
    createOrientation: PropTypes.func.isRequired
  };

  state = {
    activeTab: null,
    modalIsOpen: false
  };

  componentDidMount () {
    const hash = stripHash(this.props.location.hash);
    let activeTab = orientationTabs.orientations;
    if (Object.values(orientationTabs).includes(hash)) {
      activeTab = hash;
    }
    this.setState({ activeTab });
    this.props.getOrientationLocationsList();
  };

  setActiveTab = (activeTab, event) => {
    event.preventDefault();
    this.setState({ activeTab });
    pushHistoryState(`${this.props.match.url}#${activeTab}`);
  };

  toggleModal = () => {
    this.setState(prevState => ({
      modalIsOpen: !prevState.modalIsOpen
    }));
  };

  showUpdatedOrientationsTab = () => {
    if (this.state.activeTab !== orientationTabs.orientations) {
      this.setState({ activeTab: orientationTabs.orientations });
      pushHistoryState(`${this.props.match.url}#${orientationTabs.orientations}`);
    } else {
      this.props.getOrientationsList();
    }
  };

  render () {
    const { activeTab } = this.state;
    const { location, history, locationsList, createOrientation } = this.props;
    return (
      <Fragment>
        <ListPageHeader onClick={this.toggleModal} icon={faCommentAlt} title='Phone Screens' />
        <CreateOrientationModal
          isOpen={this.state.modalIsOpen}
          toggleModal={this.toggleModal}
          history={history}
          locationsList={locationsList}
          createOrientation={createOrientation}
          showUpdatedOrientationsTab={this.showUpdatedOrientationsTab}
        />
        <div className='tabs-wrapper mt-0'>
          {Object.values(orientationTabs).map(tab => (
            <a
              key={tab}
              onClick={event => this.setActiveTab(tab, event)}
              href={`${location.pathname}#${tab}`}
              className={`tab ${activeTab === tab && 'active'}`}>{tab}</a>
          ))}
        </div>
        { activeTab === orientationTabs.orientations && <OrientationsList /> }
        { activeTab === orientationTabs.locations && <LocationsList /> }
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    locationsList: state.orientations.locationsList
  };
};

const mapDispatchToProps = {
  getOrientationLocationsList, createOrientation, getOrientationsList
};

export default connect(mapStateToProps, mapDispatchToProps)(Orientations);



// WEBPACK FOOTER //
// ./src/components/app/orientations/index.js